import { styled } from 'styletron-react'

export const Monospace = styled('span', () => ({
  fontFamily: 'Inconsolata, monospace',
  fontWeight: 600,
}))
export const Monodiv = styled('div', () => ({
  fontFamily: 'Inconsolata, monospace',
  fontWeight: 600,
}))
